import React from 'react'

import { Skeleton } from '@fourthwall/components'

import { PageLayout } from '../../../../../components/common/PageLayout'

export const MemberSkeleton = () => {
  return (
    <PageLayout
      rightContent={
        <Skeleton>
          <Skeleton.Shape width="100%" height={260} />
        </Skeleton>
      }
      leftContent={
        <Skeleton gap={8}>
          <Skeleton.Shape width={150} height={22} />
          <Skeleton.Shape width="100%" height={60} />
          <Skeleton.Shape width="100%" height={250} />
        </Skeleton>
      }
    >
      <div style={{ marginBottom: 18 }}>
        <Skeleton gap={8}>
          <Skeleton.Shape width={150} height={22} />
          <Skeleton.Shape width={300} height={40} />
          <Skeleton.Shape width={450} height={22} />
        </Skeleton>
      </div>
    </PageLayout>
  )
}
